import { Role } from '@fullstory/proto/fs/services/orgs';
import { createSelector } from 'reselect';
import { rootSelector } from '../selectors';

/**
 * Returns umbrella settings.
 */
export const getUmbrellaSettings = createSelector(rootSelector, settings => settings.umbrella);

/**
 * Emails of seats eligible to be specified as a contact on an umbrella.
 */
export const getUmbrellaEligibleContactEmails = createSelector(
  getUmbrellaSettings,
  umbrellaSettings =>
    umbrellaSettings?.seats.reduce<string[]>((acc, seat) => {
      if (seat && seat.seats.some(s => s.role === Role.UMBRELLA_MANAGER)) {
        acc.push(seat.email);
      }
      return acc;
    }, []) || [],
);
